import * as React from 'react';
import { useBackdrop } from '@ovpn-ui/utils';
import { offset } from '@floating-ui/dom';
import clsx from 'clsx';
import { ClickAwayListener } from '@ovpn-ui/core';
import { Container, DropdownIcon, StyledPopper, StyledAvatar } from './ProfileMenu.styles';
import Menu from './Menu';
import { useDimensions } from '../../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultElement = 'div';
function ProfileMenu(props) {
  const {
    // content
    description,
    logoutLink,
    logoutLinkLabel,
    username,
    links,
    Trigger,
    closeOnNavigate = false,
    // appearance
    className,
    placement = 'bottom-end',
    offset: offsetValue = 8,
    // box default props
    flex = true,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    as,
    ...htmlAttributes
  } = props;
  const initials = username ? username.charAt(0).toUpperCase() : '';
  const middleware = React.useMemo(() => [offset(offsetValue)], [offsetValue]);
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [menuOpen, setMenuOpen] = React.useState(false);
  useBackdrop(menuOpen);
  const handleMenuToggle = React.useCallback(() => setMenuOpen(!menuOpen), [menuOpen]);
  const handleMenuClose = React.useCallback(e => {
    if (!(menuAnchorEl != null && menuAnchorEl.contains(e.target))) setMenuOpen(false);
  }, [menuAnchorEl]);
  const handleMenuLinkClick = React.useMemo(() => {
    if (closeOnNavigate) {
      return () => setMenuOpen(false);
    }
    return undefined;
  }, [closeOnNavigate]);
  const {
    isMobile
  } = useDimensions();
  return /*#__PURE__*/_jsxs("div", {
    className: clsx('ovpn-profile-menu-container', className),
    ...htmlAttributes,
    children: [Trigger ? ( /*#__PURE__*/React.cloneElement(Trigger, {
      className: 'ovpn-profile-menu-toggle',
      onClick: handleMenuToggle,
      ref: setMenuAnchorEl,
      menuOpen
    })) : /*#__PURE__*/_jsxs(Container, {
      className: "ovpn-profile-menu-toggle",
      onClick: handleMenuToggle,
      ref: setMenuAnchorEl,
      children: [/*#__PURE__*/_jsx(StyledAvatar, {
        title: username,
        description: description,
        name: initials
      }), /*#__PURE__*/_jsx(DropdownIcon, {
        $on: menuOpen,
        size: "sm"
      })]
    }), /*#__PURE__*/_jsx(StyledPopper, {
      className: "ovpn-profile-menu-popper",
      middleware: middleware,
      anchorEl: menuAnchorEl,
      placement: placement,
      open: menuOpen,
      mobile: isMobile,
      children: /*#__PURE__*/_jsx(ClickAwayListener, {
        onClickAway: handleMenuClose,
        children: /*#__PURE__*/_jsx(Menu, {
          description: description,
          logoutLink: logoutLink,
          logoutLinkLabel: logoutLinkLabel,
          username: username,
          links: links,
          onLinkClick: handleMenuLinkClick
        })
      })
    })]
  });
}
export default ProfileMenu;